import React, { useState, useEffect, useRef } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import Sidebar from "../Components/Sidebar/Sidebar";
import Form from "react-bootstrap/Form";
import { Roller } from "react-awesome-spinners";
import { getCalloutList, getDownloadCalloutList } from "../Api/bookingApi";
import { getstafflist } from "../Booking/Api/frontbooingApi";
import { CSVLink } from "react-csv";
import { Spinner } from "react-bootstrap";

const CalloutReport = () => {
  const [loading, setLoading] = useState(false);
  const [staffList, setStaffList] = useState([]);
  const [selectedTechnician, setSelectedTechnician] = useState("all");

  const [startDate, setStartDate] = useState(() => {
    const date = new Date();
    const first = new Date(date.getFullYear(), date.getMonth(), 1);
    return first.toISOString().split("T")[0]; // YYYY-MM-DD
  });

  const [endDate, setEndDate] = useState(() => {
    const date = new Date();
    const last = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    return last.toISOString().split("T")[0]; // YYYY-MM-DD
  });

  const [tableConfig, setTableConfig] = React.useState({
    page: 1,
    sizePerPage: 10,
    sortField: "",
    sortOrder: "",
  });
  const preventApiTrigger = useRef(false);
  const [pageOption, setPageOption] = React.useState({
    totalSize: 0,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
  });
  const [calloutData, setCalloutData] = useState([]);

  const getstaff = () => {
    getstafflist().then((res) => {
      if (res.code === 200) {
        const apiResponse = res.data;
        setStaffList(apiResponse.data);
      } else {
        alert("Something went wrong");
      }
    });
  };

  // Fetch staff list on component mount
  useEffect(() => {
    getstaff();
  }, []);

const statusFormatter = (cell, row) => {
    let badgeClass = "";
    let booking_status = "";
    switch (row.booking_status) {
      case "A":
        booking_status = "Active";
        badgeClass = "badge bg-success";
        break;
      case "C":
        booking_status = "Confirm";
        badgeClass = "badge bg-warning text-dark";
        break;
      case "R":
        booking_status = "Reject";
        badgeClass = "badge bg-info";
        break;
      case "CC":
        booking_status = "Cancel by Client";
        badgeClass = "badge bg-danger";
        break;
      case "CS":
        booking_status = "Cancel by service provider";
        badgeClass = "badge bg-danger";
        break;
      case "CO":
        booking_status = "Completed";
        badgeClass = "badge bg-danger";
        break;
      case "MN":
        booking_status = "Mark as no show";
        badgeClass = "badge bg-danger";
        break;
      case "RS":
        booking_status = "Confirmed by Client";
        badgeClass = "badge bg-danger";
        break;
      case "UC":
        booking_status = "Confirmed by Client";
        badgeClass = "badge bg-danger";
        break;
      case "Q":
        booking_status = "Confirmed by Client";
        badgeClass = "badge bg-danger";
        break;
      default:
        badgeClass = "badge bg-secondary";
    }

    return <span className={badgeClass}>{booking_status}</span>;
  };

  const columns = [
    {
      dataField: "id",
      text: "ID",
      sort: false,
      visible: true,
      formatter: (cell, row, index) => index + 1,
    },
    {
      dataField: "booking_date_time",
      text: "DATE",
      sort: true,
      visible: true,
    },
    {
      dataField: "emp_fullname",
      text: "NAME OF TECHNICIAN",
      sort: false,
      visible: true,
    },
    {
      dataField: "first_name",
      text: "CUSTOMER NAME",
      sort: false,
      visible: true,
      formatter: (cell, row) => row.first_name + " " + row.last_name,
    },
    {
      dataField: "user_email",
      text: "CUSTOMER EMAIL",
      sort: false,
      visible: true,
      formatter: (cell, row) => row.user_email,
    },
    {
      dataField: "phone",
      text: "CUSTOMER PHONE",
      sort: false,
      visible: true,
      formatter: (cell, row) => row.phone,
    },
    {
      dataField: "given_name",
      text: "ASSIGNED FSR OF CUSTOMER",
      sort: true,
      visible: true,
      formatter: (cell, row) => row.given_name || "-",
    },
    {
      dataField: "customer_stage",
      text: "CUSTOMER CURRENT STAGE",
      sort: true,
      visible: true,
    },
    {
      dataField: "zone",
      text: "ZONE NAME",
      sort: true,
      visible: true,
    },
    {
      dataField: "booking_status",
      text: "BOOKING STATUS",
      sort: true,
      formatter: statusFormatter,
      visible: true,
    },
  ];
  const visibleColumns = columns.filter((col) => col.visible);

  const pagination = paginationFactory({
    ...pageOption,
    page: tableConfig.page,
    sizePerPage: tableConfig.sizePerPage,
    lastPageText: ">>",
    firstPageText: "<<",
    nextPageText: ">",
    prePageText: "<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: function (page, sizePerPage) {
      console.log("page", page);
      console.log("sizePerPage", sizePerPage);
    },
    onSizePerPageChange: function (page, sizePerPage) {
      console.log("page", page);
      console.log("sizePerPage", sizePerPage);
    },
  });

  const clearFilters = () => {
    setStartDate(() => {
      const date = new Date();
      const first = new Date(date.getFullYear(), date.getMonth(), 1);
      return first.toISOString().split("T")[0];
    });
    setEndDate(() => {
      const date = new Date();
      const last = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      return last.toISOString().split("T")[0];
    });
    setSelectedTechnician("all");
  };

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder }
  ) => {
    if (preventApiTrigger.current) {
      preventApiTrigger.current = false;
      return;
    }

    const newPage = type === "filter" ? 1 : page;

    let newSortOrder = sortOrder;
    if (sortField === tableConfig.sortField) {
      newSortOrder = tableConfig.sortOrder === "asc" ? "desc" : "asc";
    } else {
      newSortOrder = "asc";
    }

    let safeSortField = sortField ?? "";
    let safeSortOrder = newSortOrder ?? "";

    if (safeSortField === "") {
      safeSortField = "";
    }

    if (safeSortOrder === "") {
      safeSortOrder = "";
    }

    const updatedConfig = {
      ...tableConfig,
      page: newPage,
      sizePerPage,
      sortField: safeSortField,
      sortOrder: safeSortOrder,
    };
    try {
      setTableConfig(updatedConfig);
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }

    getCalloutData(
      newPage,
      sizePerPage,
      safeSortField,
      safeSortOrder
    );
  };

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  const getCalloutData = async (
    page,
    sizePerPage,
    sortField,
    sortOrder
  ) => {
    try {
      const formData = new URLSearchParams();
      formData.append("start_date", startDate ? startDate : "2025-10-01");
      formData.append("end_date", endDate ? endDate : "2025-12-30");
      formData.append("staff", selectedTechnician !== "all" ? selectedTechnician : "");
      formData.append("page", page || 1);
      formData.append("page_size", sizePerPage || 10);
      formData.append("order_by", sortField || "");
      formData.append("order_type", sortOrder || "");

      const res = await getCalloutList(formData);
        if (res.code === 200) {
          const apiResponse = res.data;
          setCalloutData(apiResponse.data.bookings || []);
          setPageOption({
            totalSize: apiResponse.data.total_rows || 0,
            hideSizePerPage: false,
            hidePageListOnlyOnePage: true,
          });
        }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    getCalloutData(
      tableConfig.page,
      tableConfig.sizePerPage,
      tableConfig.sortField,
      tableConfig.sortOrder
    );
  }, [
    tableConfig,
    startDate,
    endDate,
    selectedTechnician,
  ]);

  const [csvReportData, setCsvReportData] = useState([]);
  const [csvLoader, setCsvLoader] = useState(false);
  const csvLinkRef = useRef();

  const getAllData = async () => {
    setCsvLoader(true);
    const formData = new URLSearchParams();
    formData.append("start_date", startDate ? startDate : "2025-10-01");
    formData.append("end_date", endDate ? endDate : "2025-12-30");
    formData.append("staff", selectedTechnician !== "all" ? selectedTechnician : "");
    formData.append("page", tableConfig.page || 1);
    formData.append("page_size", tableConfig.sizePerPage || 10);
    formData.append("order_by", tableConfig.sortField || "");
    formData.append("order_type", tableConfig.sortOrder || "");
    try {
      const res = await getDownloadCalloutList(formData);
      if (res.code === 200) {
        const apiResponse = res.data;
        setCsvReportData(apiResponse.data || []);

        setTimeout(() => {
          csvLinkRef.current.link.click();
        }, 200);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setCsvLoader(false);
    }
  };

  const csvReport = {
    data: csvReportData.map((item) => ({
      emp_fullname: (item.emp_fullname || "").trim(),
      name: (item.first_name || "").trim(),
      email: (item.user_email || "").trim(),
      phone: (item.phone || "").trim(),
      customer_stage: (item.customer_stage || "").trim(),
      booking_status: (item.booking_status || "").trim(),
      booking_date_time: (item.booking_date_time || "").trim(),
      coupon_code: (item.coupon_code || "").trim(),
      app_notes: (item.app_notes || "").trim(),
      billed_amount: (item.billed_amount || "").trim(),
      book_date: (item.book_date || "").trim(),
      zone: (item.zone || "").trim(),
    })),
    headers: [
      { label: "NAME OF TECHNICIAN", key: "emp_fullname" },
      { label: "CUSTOMER NAME", key: "name" },
      { label: "CUSTOMER EMAIL", key: "email" },
      { label: "CUSTOMER PHONE", key: "phone" },
      { label: "CUSTOMER CURRENT STAGE", key: "customer_stage" },
      { label: "BOOKING STATUS", key: "booking_status" },
      { label: "BOOKING DATE", key: "booking_date_time" },
      {label: "PROMO CODE", key: "coupon_code"},
      {label: "NOTE", key: "app_notes"},
      {label: "BILLED AMOUNT", key: "billed_amount"},
      {label: "BOOKED ON", key: "book_date"},
      { label: "PROMO CODE", key: "coupon_code" },
      { label: "ZONE NAME", key: "zone" },
    ],
    filename: "CalloutData.csv",
  };

  return (
    <div>
      {loading ? (
        <div className="loading">
          <Roller />
        </div>
      ) : (
        <div className="dashboard-container d-flex">
          <div className="sidebar-container">
            <Sidebar />
          </div>
          <div className="main-container">
            <div className="main-page-body-content">
              <div className="main-page-body-content-body">
                <div className="main-page-body-content-body-container">
                  <div className="container-fulid">
                    <div className="table-card">
                      <div className="card-body table-card-body">
                        <div className="table-card-header mb-4 d-flex justify-content-between">
                          <h5 className="card-title">Callout Report</h5>
                        </div>
                        <div className="table-card-body-inner">
                          <div className="animated fadeIn">
                            <div className="row">
                              <div className="col-md-12">
                                <div className="card">
                                  <div className="card-header table-card-header">
                                    <div className="row g-4 align-items-center">
                                      <div className="col-md-3">
                                        <Form.Group>
                                          <Form.Label className="mb-2 fw-semibold">
                                            Start Date
                                          </Form.Label>
                                          <Form.Control
                                            type="date"
                                            value={startDate}
                                            onChange={(e) => {
                                              setStartDate(e.target.value);
                                              setTableConfig((prev) => ({
                                                ...prev,
                                                page: 1,
                                              }));
                                            }}
                                            placeholder="Select start date"
                                          />
                                        </Form.Group>
                                      </div>

                                      <div className="col-md-3">
                                        <Form.Group>
                                          <Form.Label className="mb-2 fw-semibold">
                                            End Date
                                          </Form.Label>
                                          <Form.Control
                                            type="date"
                                            value={endDate}
                                            onChange={(e) => {
                                              setEndDate(e.target.value);
                                              setTableConfig((prev) => ({
                                                ...prev,
                                                page: 1,
                                              }));
                                            }}
                                            min={startDate}
                                            placeholder="Select end date"
                                          />
                                        </Form.Group>
                                      </div>

                                      <div className="col-md-2">
                                        <Form.Group>
                                          <Form.Label className="mb-2 fw-semibold">
                                            Technician
                                          </Form.Label>
                                          <Form.Select
                                            value={selectedTechnician}
                                            onChange={(e) => {
                                              setSelectedTechnician(e.target.value);
                                              setTableConfig((prev) => ({
                                                ...prev,
                                                page: 1,
                                              }));
                                            }}
                                          >
                                            <option value="all">All Technicians</option>
                                            {staffList.map((staff) => (
                                              <option key={staff.id} value={staff.id}>
                                                {staff.fullname || staff.name}
                                              </option>
                                            ))}
                                          </Form.Select>
                                        </Form.Group>
                                      </div>

                                      <div className="col-md-2 mt-5">
                                        <button
                                          className="btn btn-primary downloads-btn-preview w-100"
                                          style={{ whiteSpace: "nowrap" }}
                                          onClick={() => getAllData()}
                                        >
                                          {csvLoader ? (
                                            <Spinner
                                              animation="border"
                                              role="status"
                                              size="sm"
                                              className="me-1 "
                                            />
                                          ) : (
                                            "Export CSV"
                                          )}
                                        </button>

                                        <CSVLink
                                          {...csvReport}
                                          ref={csvLinkRef}
                                          style={{ display: "none" }}
                                        />
                                      </div>
                                      <div className="col-md-2 d-flex align-items-end mt-5">
                                        <button
                                          className="btn btn-secondary w-100"
                                          onClick={clearFilters}
                                        >
                                          Clear
                                        </button>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="card-body">
                                    {calloutData && calloutData.length > 0 ? (
                                      <>
                                        <BootstrapTable
                                          bootstrap4
                                          keyField="id"
                                          data={calloutData}
                                          remote={{
                                            pagination: true,
                                            sort: true,
                                          }}
                                          onTableChange={handleTableChange}
                                          columns={visibleColumns}
                                          pagination={pagination}
                                        />
                                      </>
                                    ) : (
                                      <div className="text-center py-5">
                                        <h5 className="text-muted">
                                          No Data Found
                                        </h5>
                                        <p className="text-muted">
                                          There are no callout records
                                          available matching your filters.
                                        </p>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CalloutReport;

